// -----------------------------------------------------------------
// <copyright
//   file="Izenda.ConnectionItem.js"
//   company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// -----------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { action } from 'mobx';

import classnames from 'classnames';
import constants from 'logic/data/Izenda.ConnectionConstants';

import uiState from 'logic/Izenda.UiState';
import localizer from 'share/localization/Izenda.Localizer';
import TextHighLight from 'share/components/controls/Izenda.TextHighLight';
import connect from 'share/enhancers/Izenda.Connect';
import { isNil } from "lodash/fp";

/**
 * Connection Item component
 */
@connect()
export default class ConnectionItem extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    dataSource: PropTypes.object.isRequired,
    isMiddlePanelMinimum: PropTypes.bool.isRequired
  };

  /**
   * Toggle visibility click handler.
   */
  onToggleVisibility = e => {
    e.stopPropagation();

    const { props } = this;
    const { store, loader, dataSource } = props;

    const message = dataSource.visible
      ? constants.VISIBLE_MESSAGE
      : constants.INVISIBLE_MESSAGE;
    props
      .confirmFn('Confirmation', {
        description: message
      })
      .then(loader.startLoading.bind(loader))
      .then(() => store.updateToggleVisibility(dataSource))
      .finally(loader.endLoading.bind(loader));
    return false;
  };

  /**
   * Delete click handler.
   */
  onDelete = e => {
    e.stopPropagation();

    const { props } = this;
    const { store, loader, dataSource } = props;

    props
      .confirmFn('Confirmation', {
        description: constants.DELETE_MESSAGE
      })
      .then(loader.startLoading.bind(loader))
      .then(() => store.deleteFromSolar(dataSource))
      .then(success => success ? store.deleteConnection(dataSource) : false)
      .finally(loader.endLoading.bind(loader));
  };

  onSelectItem = e => {
    e.stopPropagation();

    const { store, dataSource } = this.props;

    // Only re-select a current item when it's actually differrent regarding to
    // its id value.
    if (store.item.id !== dataSource.id) {
      this.props.confirmDirtyForm(uiState.isDirty, {
        onConfirmDirtyForm: uiState.onOkDirtyForm
      }).then(() => {
        this.setConnection();
      });
    }
  };

  /**
   * Set current connection
   */
  setConnection() {
    const { store, dataSource } = this.props;
    store.setConnectionDetail(dataSource);
  }

  render() {
    const {
      isMiddlePanelMinimum,
      dataSource,
      store: {
        filter,
        item: {
          id: selectedId
        }
      }
    } = this.props;

    const selectedClass = classnames('truncate', 'overflow-text', {
      selected: dataSource.id === selectedId
    });

    const serverTypeNameClasses = classnames('pull-left', {
      hidden: isMiddlePanelMinimum
    });

    const iconClasses = classnames(
      'white-space-normal',
      {
        'icon-eye': dataSource.visible,
        'icon-eye-off': !dataSource.visible
      },
      'pull-right'
    );

    const detectChangesIcon =
      dataSource.change !== constants.DETECTED_CHANGE_LEVEL.NONE ? (
        <span
          className='icon-attention warning-color pull-left'
          title={localizer.getText('CONNECTION_DETECT_CHANGE_ICON_TOOLTIP')}
        />
      ) : (
        ''
      );

    const tooltip = `[${dataSource.serverTypeName}] ${dataSource.name}`;

    const dbIconClasses = classnames('pull-left izenda-Connection-dbTypeIcon small u_noMarginLeft u_noMarginTop u_noMarginBottom u_marginRight u_noPaddingAll u_inlineBlock', {
      [dataSource.serverTypeName]: !isNil(dataSource.serverTypeName)
    });

    return (
      <div>
        {/* confirm popup container prevent onclick event in popup to invoke the onSelect*/}
        <div className={selectedClass} onClick={this.onSelectItem}>
          <span className={dbIconClasses}/>
          <strong className={serverTypeNameClasses}>[{dataSource.serverTypeName}]&nbsp;</strong>
          <TextHighLight
            className='pull-left connection-string-name'
            highlight={filter}
            text={dataSource.name || localizer.getText('CONNECTION_EMPTY_NAME_LABEL')}
            tooltip={tooltip}
          />
          {detectChangesIcon}
          <span className='icon-cancel pull-right white-space-normal' onClick={this.onDelete}/>
          <span className={iconClasses} onClick={this.onToggleVisibility}/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionList/Izenda.ConnectionItem.js